import React from 'react';
import PropTypes from 'prop-types';
import './RealtimeStatusNotice.css';

const RealtimeStatusNotice = ({ sessionStatus, pendingMutationCount = 0, notice = null, onDismiss }) => {
  const reconnecting = sessionStatus === 'reconnecting';
  const joining = sessionStatus === 'joining';
  const syncing = !reconnecting && !joining && pendingMutationCount > 0;
  if (!reconnecting && !joining && !syncing && !notice?.message) return null;

  const message = reconnecting
    ? `Connection interrupted. ${pendingMutationCount > 0 ? `${pendingMutationCount} local change${pendingMutationCount === 1 ? '' : 's'} will synchronize after reconnection.` : 'Reconnecting to the BattleRoom…'} Please wait.`
    : joining
      ? 'Loading the BattleRoom… Please wait.'
    : syncing
      ? `Synchronizing ${pendingMutationCount} BattleRoom change${pendingMutationCount === 1 ? '' : 's'}…`
      : notice.message;

  return (
    <div className={`realtime-status-notice ${notice?.message && !reconnecting && !joining && !syncing ? 'is-warning' : ''}`} role="status" aria-live="polite">
      <span className="realtime-status-notice__state">{reconnecting ? 'Reconnecting' : joining ? 'Loading BattleRoom' : syncing ? 'Synchronizing' : notice.title}</span>
      <span>{message}</span>
      {notice?.message && !reconnecting && !joining && !syncing && (
        <button type="button" onClick={onDismiss} aria-label={`Dismiss ${notice.title || 'BattleRoom notice'}`}>Dismiss</button>
      )}
    </div>
  );
};

RealtimeStatusNotice.propTypes = {
  sessionStatus: PropTypes.string,
  pendingMutationCount: PropTypes.number,
  notice: PropTypes.shape({
    title: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
  }),
  onDismiss: PropTypes.func,
};

export default RealtimeStatusNotice;
